/* eslint @typescript-eslint/explicit-function-return-type: off */

import * as Routes from '../routes/SpreadsheetReportConfigs';
import * as RESTAPI from '../lib/RESTAPI';

export const create = (
  projectId,
  spreadsheetReportConfigData,
  copiedSpreadsheetConfigId
) => {
  const url = Routes.createPath(projectId);
  return RESTAPI.post(
    url,
    {
      spreadsheet_report_config: spreadsheetReportConfigData,
      copied_spreadsheet_config_id: copiedSpreadsheetConfigId,
    },
    {
      isSkipConvertSnakeCase: true,
    }
  );
};

export const getGoogleProfile = (projectId, spreadsheetReportConfigId) => {
  const url = Routes.getGoogleProfilePath();
  return RESTAPI.get(url, {
    projectId,
    id: spreadsheetReportConfigId,
  });
};

export const getDetails = (projectId, spreadsheetReportConfigId) => {
  const url = Routes.detailsPath(projectId, spreadsheetReportConfigId);
  return RESTAPI.get(url);
};

export const getSheetListBySpreadsheetId = (
  projectId,
  spreadsheetId,
  spreadsheetReportConfigId
) => {
  const url = Routes.getSheetListBySpreadsheetIdPath();
  return RESTAPI.get(url, {
    projectId,
    spreadsheetId,
    id: spreadsheetReportConfigId,
  });
};

export const getPanelPreviewData = (
  projectId,
  spreadsheetReportConfigData,
  locale
) => {
  const url = Routes.getPanelPreviewDataPath(projectId, locale);
  return RESTAPI.post(url, spreadsheetReportConfigData);
};

export const update = (
  projectId,
  spreadsheetReportConfigId,
  spreadsheetReportConfigData
) => {
  const url = Routes.updatePath(projectId, spreadsheetReportConfigId);
  return RESTAPI.patch(
    url,
    {
      spreadsheet_report_config: spreadsheetReportConfigData,
    },
    {
      isSkipConvertSnakeCase: true,
    }
  );
};

export const clearGoogleProfile = (projectId) => {
  const url = Routes.clearGoogleProfilePath(projectId);
  return RESTAPI.destroy(url);
};

export const getImportableSpreadsheetReportConfigs = (currentProjectId) => {
  const url = Routes.importSpreadsheetConfigCandidatesPath();
  return RESTAPI.get(url, { currentProjectId });
};
